import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64fdce34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base form-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Lesson No.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Lesson Name", -1))
const _hoisted_4 = { class: "footer-setting" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "flex justify-center mt-3"
}

import { computed, ref } from 'vue'
import useSpaceApi from '@/composables/api/useSpaceApi'
import useNotify from '@/composables/useNotify'


export default /*#__PURE__*/_defineComponent({
  __name: 'LessonPopup',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  classId: {
    type: Number,
    required: true,
  },
  isFromLessonBtn: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:modelValue', 'success', 'leave'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const notification = useNotify()
const { saveLesson } = useSpaceApi()
const lessonNo = ref(0)
const lessonName = ref('')
const disabled = computed(() => (lessonNo.value && lessonName.value ? false : true))
const submit = async () => {
  const res = await saveLesson({
    lessonNumber: lessonNo.value,
    lessonName: lessonName.value,
    classId: props.classId,
  })
  if (res.status === 201) {
    notification.success({ text: 'Submit Lesson Success!' })
    emit('success')
    close()
  } else {
    notification.warning({ text: 'Could not submit the lesson. Please try again.' })
  }
}
const close = () => {
  emit('update:modelValue', !props.modelValue)
}

return (_ctx: any,_cache: any) => {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    title: "Which lesson did you teach?",
    open: __props.modelValue,
    onClose: close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          disabled: disabled.value,
          type: "button",
          class: "btn btn-primary",
          onClick: submit
        }, " Submit ", 8, _hoisted_5),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          onClick: close
        }, "Cancel")
      ]),
      (!__props.isFromLessonBtn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-link",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('leave')))
            }, " Or leave this room ")
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((lessonNo).value = $event)),
          type: "number",
          class: "mb-3"
        }, null, 512), [
          [_vModelText, lessonNo.value]
        ]),
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lessonName).value = $event)),
          type: "type"
        }, null, 512), [
          [_vModelText, lessonName.value]
        ])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})